import { render } from "./ErrorPageComponent.vue?vue&type=template&id=754941b3"
import script from "./ErrorPageComponent.vue?vue&type=script&lang=js"
export * from "./ErrorPageComponent.vue?vue&type=script&lang=js"

import "./ErrorPageComponent.vue?vue&type=style&index=0&id=754941b3&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__